<template>
  <section
    id="printMe"
    class="lien-summary"
  >
    <div v-if="!identified">
      <div class="column is-4-desktop is-offset-4-desktop">
        <form @submit="handleIdentify">
          <div class="field">
            <div class="control">
              <label class="label">
                <span>Password</span>
                <span
                  :data-tooltip="'Required field'"
                  class="tooltip has-tooltip-right has-tooltip-arrow"
                >
                  <img
                    src="../../../public/assets/img/info.svg"
                    alt=""
                  >
                </span>
              </label>
              <p class="control has-icons-left has-icons-right">
                <input
                  ref="password"
                  class="input is-mandatory"
                  name="password"
                  :class="passwordError.visible ? 'has-error' : ''"
                  type="password"
                  placeholder="Your Password"
                  value=""
                >
                <span
                  ref="eye"
                  class="icon is-small is-right"
                  @click="showPassword"
                >
                  <i class="fas fa-eye" />
                </span>
              </p>
              <span
                v-if="passwordError.visible"
                class="error-message"
              >{{
                passwordError.message
              }}</span>
            </div>
          </div>
          <button
            class="button primary"
            type="submit"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
    <div
      v-else
      class="summary"
    >
      <div class="summary-header">
        <router-link
          v-if="loggedIn"
          v-show="!printing"
          class="navbar-item navbar-logo hide-on-print"
          to="/"
        >
          Self Storage Solution
        </router-link>
        <div class="print hide-on-print">
          <!--<button type="button" class="button is-outlined toggle-button" :disabled="!data.length" v-on:click="toggleAll">Toggle all</button>-->
          <button
            v-show="!printing"
            type="button"
            class="button print-button"
            :disabled="!data.length"
            @click="print"
          >
            Print
          </button>
        </div>
      </div>
      <div
        v-if="lienLogs.length && isLogsVisible"
        class="lien-log invisibleOnPrint"
      >
        <h4
          class="invisibleOnPrint"
          style="font-weight: 500; font-size: 1.25rem"
        >
          Lien logs
        </h4>
        <div
          v-for="(log, id) in lienLogs"
          :key="id"
          class="log__container invisibleOnPrint"
        >
          <p>{{ log.activity }}</p>
          <p v-if="log.performer">
            <span>{{ log.performer }}</span>
          </p>
          <p v-else>
            <span>initiated by system</span>
          </p>
          <p>
            <span>{{ log.date }}</span>
          </p>
          <p v-if="log.notes">
            <span>{{ log.notes }}</span>
          </p>
        </div>
      </div>
      <div class="accordion-container">
        <accordion
          :is-multiple="true"
          :accordion-data="data"
        />
        <div
          v-if="auctionInfo.start && auctionInfo.end"
          class="auction-info"
        >
          <p v-if="auctionInfo.start">
            <span
              id="st"
              class="info"
            >Auction start:</span>
            <span>{{ auctionInfo.start }}</span>
          </p>
          <p v-if="auctionInfo.end">
            <span class="info">Auction end:</span>
            <span>{{ auctionInfo.end }}</span>
          </p>
        </div>
        <div
          v-if="image"
          class="image"
        >
          <img
            :src="image"
            alt="img"
            class="thumbnail-image"
          >
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import VueHtmlToPaper from 'vue-html-to-paper';
import Vue from 'vue';
import Accordion from '../core/Accordion.vue';
import AuthService from '../../services/auth.service';
import store from '../../store';
import { Roles } from '../../constants';

const authService = new AuthService();
const options = {
  name: '_blank',
  styles: ['/print.css']
};
Vue.use(VueHtmlToPaper, options);
export default {
  name: 'LienSummary',
  components: {
    Accordion
  },
  data() {
    return {
      printing: false,
      image: null,
      identified: false,
      isLogsVisible: this.$store.state.user.role === Roles.SUPER_ADMIN,
      auctionInfo: {
        start: null,
        end: null
      },
      lienLogs: [],
      passwordError: {
        message: '',
        visible: false
      },
      uuid: '',
      passwordInputConfig: {
        text: {
          type: 'password',
          color: '#dbdbdb'
        },
        password: {
          type: 'text',
          color: '#000'
        }
      },
      data: [],
      tempData: [],
      possibleStepName: {
        1: { id_workflow_step_name: 1, name: 'Lien letter notice 1' },
        2: { id_workflow_step_name: 2, name: 'Lien letter notice 2' },
        3: { id_workflow_step_name: 3, name: 'Lien to Sale Letter 1' },
        4: { id_workflow_step_name: 4, name: 'Lien to Sale Letter 2' },
        5: { id_workflow_step_name: 5, name: 'Newspaper 1' },
        6: { id_workflow_step_name: 6, name: 'Newspaper 2' }
      },
      possibleStepList: {
        1: { name: 'SMS', category: 'notification' },
        2: { name: 'Email', category: 'notification' },
        3: { name: 'USPS', category: 'notification' },
        5: { name: 'Newspaper publication', category: 'ad' }
      },
      loggedIn: false,
      store
    };
  },
  mounted() {
    this.$root.showHeader = false;
    this.isLogsVisible = this.$store.state.user.role === Roles.SUPER_ADMIN;
    this.uuid = this.$route.params.uuid;
    window.addEventListener('keydown', this.handleKeyDown);
    const isUserLogged = this.$store.state.accessToken
      && this.$store.state.expirationDate > new Date().getTime();

    if (isUserLogged) {
      this.identified = true;
      this.loggedIn = true;
      this.handleIdentify(null, 'TexasAjM99');
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    handleIdentify(e, pass) {
      e?.preventDefault();
      const password = pass || this.$refs.password.value;
      if (!password) {
        this.passwordError = {
          message: 'Password is required',
          visible: true
        };
        this.$root.$emit('showToast', {
          message: 'Password is required',
          options: { cssClass: 'is-danger', duration: 7500 }
        });
        return;
      }
      const self = this;
      const data = new FormData();
      data.append('password', password);

      authService
        .identify(data, this.uuid)
        .then((response) => {
          const { status, message, result } = response.data;
          if (status === 'success') {
            const firstLien = result.current_liens?.length
              ? result.current_liens[0]
              : {};
            self.image = result.renter.base64_image;
            self.auctionInfo = {
              start: firstLien.auction,
              end: firstLien.auction_end
            };
            self.lienLogs = firstLien.logs;
            self.prepareAccordionData(result);
          } else {
            self.passwordError = {
              message,
              visible: true
            };
            self.$root.$emit('showToast', {
              message:
                message
                || 'Impossible to perform this action. Be sure to be connected and to have access to this action',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message: 'Technical issue. Please try again later',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    prepareAccordionData(data) {
      const accordionData = [];

      if (data?.current_liens?.[0]?.steps) {
        data.current_liens[0].steps.map((step, index) => {
          const title = this.getStepTitle(step);
          const details = this.getDetails2(step);
          accordionData.push({
            active: !index,
            title,
            details,
            status: step.status,
            date: step.date
          });
        });
      }

      this.data = [...accordionData];
      this.identified = true;
    },
    getStepTitle(step) {
      /* eslint-disable camelcase */
      const {
        is_executed,
        id_workflow_step_type,
        id_workflow_step_name,
        execution_date
      } = step;
      const stepInfo = [
        this.possibleStepList[id_workflow_step_type]?.name,
        this.possibleStepName[id_workflow_step_name]?.name
      ]
        .filter((it) => it)
        .join(': ');
      if (!is_executed) {
        return `${stepInfo} - Not completed`;
      }

      const details = this.getDetails(step);
      const completionInfo = details
        ? execution_date
        : `Completed manually - ${execution_date}`;
      return [stepInfo, completionInfo].filter((it) => it).join(' - ');
    },
    getDetails(step) {
      switch (step.id_workflow_step_type) {
        case 2:
          return step.message ? step.message : step?.details?.message || '';
        case 1:
          return step.message ? step.message : step?.details?.message || '';
        case 3:
          return step.usps_image
            ? `<img class="summary__imgs" style="width:100%; margin: 10px 0; object-fit: contain;" src="${step.usps_image}" >`
            : '';
        case 5:
          return step.ordered || '';
        default:
          return null;
      }
    },
    getDetails2(step) {
      let data = '';
      if (step.logs?.length && this.isLogsVisible) {
        data += '<br/><br/><h4 class="invisibleOnPrint" style="font-weight: 500; font-size: 1.25rem;">Logs</h4>';
        step.logs?.forEach((item) => {
          data += `<div class="logs__contianer invisibleOnPrint">
            <span>${item?.activity}</span>
            <span>${item?.performer ? item.performer : 'initiated by system'
}</span>
            <span>${item?.date}</span>
            <span>${item?.notes ? item?.notes : ''}</span>
          </div>`;
        });
      }
      switch (step.id_workflow_step_type) {
        case 2:
          data += step?.details?.message || '';
          break;
        case 1:
          data += step.message ? step.message : step?.details?.message || '';
          break;
        case 3:
          data += step.usps_image
            ? `<img class="summary__imgs" style="width:100%; margin: 10px 0; object-fit: contain;" src="${step.usps_image}" >`
            : '';
          break;
        case 5:
          data += step.ordered || '';
          break;
        default:
          data += '';
          break;
      }
      if (step.image_manual && step.image_manual !== 'false') {
        data += `<img class="summary__imgs" style="width:100%; margin: 10px 0; object-fit: contain; display:block" src="${step.image_manual}" >`;
      }
      if (step.images_pdfs) {
        step.images_pdfs.forEach((item) => {
          if (item.mime && item.mime !== 'pdf') {
            data += `<div class="invisibleOnPrint" style="${this.isLogsVisible ? '' : 'display: none'
            }"> ${item?.acitity ? item?.activity : ''} ${item?.performer ? item?.performer : ''
            } ${item?.date ? item?.date : ''} ${item?.notes ? item?.notes : ''
            } </div>  <img class="summary__imgs" style="width:100%; margin: 10px 0; object-fit: contain; display:block" src="${item.path
            }" />`;
          } else {
            data += `<div class="invisibleOnPrint" style="${this.isLogsVisible ? '' : 'display: none'
            }"> ${item?.acitity ? item?.activity : ''} ${item?.performer ? item?.performer : ''
            } ${item?.date ? item?.date : ''} ${item?.notes ? item?.notes : ''
            } </div>  <iframe  class="summary__imgs invisibleOnPrint" style="width:100%; height: 900px; margin: 10px 0; object-fit: contain;" src="${item.path
            }" >
            </iframe>
             <a style="margin: 10px 0; display:none " class="button visibleOnPrint d_none is-info-light" href="${item.path}">Download pdf</a>`;
          }
          if (item?.slug === 'lien_task_file_added') {
            data += `
              <p> The document id: ${item?.id} was added by the ${item?.performer} at the ${item?.date} </p>
            `;
          } else if (item?.slug === 'lien_task_file_deleted') {
            data += `
              <p> The document id: ${item?.id} was deleted by the ${item?.performer} at the ${item?.deleted_at} </p>
            `;
          }
        });
      }
      if (step.pdf) {
        data += ` <iframe  class="summary__imgs invisibleOnPrint" style="width:100%; height: 900px; margin: 10px 0; object-fit: contain;" src="${step.pdf
        }" >
            </iframe>`;
        data += ` <a style="margin: 10px 0; display: none " class="button visibleOnPrint is-info-light" href="${step.pdf}">Download pdf</a>`;
      }
      if (step.description_manual) {
        data += `<br/>${step.description_manual}`;
      }
      if (step.news_image) {
        data += `<img class="summary__imgs" style="width:100%; margin: 10px 0; object-fit: contain; marginTop:10px" src="${step.news_image}" >`;
      }
      if (step.letters?.length) {
        step.letters.forEach((item) => {
          data += `<iframe  class="summary__imgs invisibleOnPrint" style="width:100%; height: 900px; margin: 10px 0; object-fit: contain;" src="${item.path
          }" >
            </iframe>
            <a style="margin: 10px 0; display:none " class="button visibleOnPrint d_none is-info-light" href="${item.path}">Download pdf</a>
            Created at: ${item.created_at} ${item.is_alternate ? ' Alternate latter' : ''}`;
        });
      }
      if (step.firmbooks?.length) {
        step.firmbooks.forEach((item) => {
          data += `<iframe  class="summary__imgs invisibleOnPrint" style="width:100%; height: 900px; margin: 10px 0; object-fit: contain;" src="${item.path
          }" >
            </iframe>
            <a style="margin: 10px 0; display:none " class="button visibleOnPrint d_none is-info-light" href="${item.path}">Download pdf</a>
            Created at: ${item.created_at}  USPS Firm Book`;
        });
      }
      return data;
    },
    showPassword(event) {
      if (event) {
        event.preventDefault();
      }
      const { type, color } = this.passwordInputConfig[this.$refs.password.type];
      this.$refs.password.type = type;
      this.$refs.eye.style.color = color;
    },
    async print() {
      this.printing = true;
      await this.$nextTick();
      await this.$htmlToPaper('printMe', null, () => {
        this.printing = false;
      });
    },
    toggleAll() {
      const isAllOpened = this.data.every((it) => it.active);
      this.data = [...this.data.map((it) => ({ ...it, active: !isAllOpened }))];
    },
    handleKeyDown(e) {
      if (
        (e.ctrlKey || e.metaKey)
        && (e.key.toLowerCase() === 'p' || [16, 80, 112].includes(e.charCode))
      ) {
        e.cancelBubble = true;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.print();
      }
    }
  }
};
</script>
<style
  scoped
  src="../../../public/assets/css/bulma-extension/bulma-tooltip.min.css"
>
</style>
<style scoped lang="scss">
.d_none{
  display: none !important;
}
.lien-summary {
  padding: 10px 20px;
}

.log__container {
  display: flex;
  align-items: center;
  justify-content: left;
}

.log__container>* {
  margin: 0;
  margin-right: 10px;
}

.lien-summary {
  .column {
    margin: 0;
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);

    .field {
      .control {

        &.has-icons-left,
        &.has-icons-right {
          .icon {
            height: auto;
            top: 50%;
            transform: translateY(-50%);
            pointer-events: inherit;
            cursor: pointer;
          }
        }

        .error-message {
          color: #ff0000;
          font-size: 14px;
          margin-top: 5px;
          line-height: 10px;
          display: block;
        }
      }
    }
  }

  .summary {
    .summary-header {
      display: flex;
      justify-content: space-between;
      margin: 15px 0;

      .print {
        display: flex;

        .print-button {
          background-color: #2979ff;
          color: #fff;
        }

        .toggle-button {
          margin-right: 15px;
        }

        &.hidden {
          display: none;
        }
      }
    }

    .accordion-container {
      padding-top: 50px;

      .auction-info {
        margin-top: 30px;

        p {
          display: flex;

          .info {
            min-width: 120px;
          }
        }
      }
    }
  }
}
</style>
